<script setup>
import StatsComponent from "@/Components/PayPeriod/StatsComponent.vue";
import DetailsComponent from "@/Components/PayPeriod/DetailsComponent.vue";
import PayPeriodAllUnreleased from "@/Components/HoldBacks/PayPeriodAllUnreleased.vue";
import {useRoute} from "vue-router";
import {Permissions} from "@/Utils/Permissions";
import {onMounted, reactive} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
const route = useRoute();

const data = reactive({
  loading: true,
  exists: false
});

const checkExists = () => {
  data.loading = true;
  data.exists = false;

  if(route.params.payperiodId.toLowerCase() === 'pending') {
    data.exists = true;
    data.loading = false;
  }
  else {
    ApiWrapper.post('pay-period', 'pay-period-exists', {
      payPeriodId: route.params.payperiodId
    })
        .then((response) => {
          data.exists = true;
        })
        .catch((e) => {
          data.exists = false;
        })
        .finally(() => {
          data.loading = false;
        });
  }
}
onMounted(() => {
  if(route.params.id === 'Pending' || route.params.id === 'pending') {
    data.loading = false;
    data.exists = true;
  }
  else {
    checkExists();
  }
});


</script>

<template>
  <template v-if="data.loading">
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-card class="elevation-2" height="auto" width="auto">
            <v-skeleton-loader type="card"></v-skeleton-loader>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </template>

  <template v-if="!data.loading && !data.exists">
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-card class="elevation-2" height="auto" width="auto">
            <v-alert title="Not Found" text="The specified pay period could not be found" type="error"></v-alert>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </template>

  <template v-if="!data.loading && data.exists">
    <v-row v-if="Permissions.checkPermissions(['pay-periods.list'])">
      <v-col cols="12">
        <StatsComponent contextSchemaA="payperiods" :contextIdA="route.params.payperiodId"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['pay-periods.list'])">
      <v-col cols="12">
        <DetailsComponent contextSchemaA="payperiods" :contextIdA="route.params.payperiodId"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['holdbacks.unreleased'])">
      <v-col cols="12">
        <PayPeriodAllUnreleased contextSchemaA="payperiods" :contextIdA="route.params.payperiodId"/>
      </v-col>
    </v-row>
  </template>
</template>

<style scoped>

</style>